export const StudentSortKey = {
	NAME: 'NAME'
} as const;

export const ALL_GROUPS_FILTER_ID = 0;
export const UNASSIGNED_GROUP_ID = 0;
export const ALL_GRADES_FILTER_ID = 'ALL';

export const ALL_GROUPS_FILTER_LABEL = 'Tüm Gruplar';
export const GRADE_FILTER_PLACEHOLDER = 'Sınıf';
export const ALL_GRADES_FILTER_LABEL = 'Tüm Sınıflar';
export const UNASSIGNED_GROUP_LABEL = 'Atanmadı';
export const GROUP_STUDENTS_LABEL = 'Grupla';
export const GROUP_MENU_UPWARD_MIN_ROWS = 4;
export const GROUP_MENU_UPWARD_ROW_COUNT = 2;

export const DEFAULT_SORT_DIRECTION = 'asc';

export const GROUP_DRAWER_SEARCH_PLACEHOLDER = 'Bu grupta ara...';
export const GROUP_DRAWER_STUDENTS_TAB_LABEL = 'Öğrenciler';
export const GROUP_DRAWER_AVATAR_LIMIT = 3;
export const GROUP_NAME_INPUT_ID = 'group-drawer-name';
export const GROUP_DRAWER_ADD_STUDENT_LABEL = 'Öğrenci Ekle';
export const GROUP_DRAWER_ADD_DONE_LABEL = 'Bitti';
export const GROUP_DRAWER_ADD_ROW_LABEL = 'Ekle';
export const GROUP_DRAWER_ADD_SEARCH_PLACEHOLDER = 'Eklenecek öğrenciyi ara...';
export const GROUP_DRAWER_ADD_EMPTY_TEXT = 'Eklenebilecek öğrenci bulunamadı.';
export const GROUP_DRAWER_ADD_SECTION_TITLE = 'Gruba Eklenebilecek Öğrenciler';
export const RemoveMemberKind = {
	STUDENT: 'STUDENT',
	EXPERT: 'EXPERT'
} as const;

export const GROUP_CHANGE_DIALOG = {
	MOVE_TITLE: 'Grubu değiştir',
	REMOVE_TITLE: 'Öğrenciyi gruptan çıkar',
	STUDENT_PREFIX: 'adlı öğrenci',
	FROM_SUFFIX: 'grubundan',
	MOVE_SUFFIX: 'grubuna taşınacak.',
	ADD_SUFFIX: 'grubuna eklenecek.',
	REMOVE_SUFFIX: 'çıkarılacak.',
	QUESTION: 'Devam etmek istiyor musunuz?',
	MOVE_CONFIRM_LABEL: 'Onayla',
	REMOVE_CONFIRM_LABEL: 'Çıkar',
	CANCEL_LABEL: 'Vazgeç'
} as const;

export const REMOVE_MEMBER_DIALOG = {
	TITLE: {
		[RemoveMemberKind.STUDENT]: 'Öğrenciyi gruptan çıkar',
		[RemoveMemberKind.EXPERT]: 'Uzmanı akademik kuruldan çıkar'
	},
	DESCRIPTION_PREFIX: {
		[RemoveMemberKind.STUDENT]: 'adlı öğrenci',
		[RemoveMemberKind.EXPERT]: 'adlı uzman'
	},
	DESCRIPTION_SUFFIX: {
		[RemoveMemberKind.STUDENT]: 'grubundan çıkarılacak. Devam etmek istiyor musunuz?',
		[RemoveMemberKind.EXPERT]: 'grubunun akademik kurulundan çıkarılacak. Devam etmek istiyor musunuz?'
	},
	CONFIRM_LABEL: 'Çıkar',
	CANCEL_LABEL: 'Vazgeç'
} as const;
